import {
   isOverlayRatingInput,
   resolveRatingInput,
   type RatingInputMode,
} from "./checklistRating";

export const RANK_1_TO_4_MIN = 1;
export const RANK_1_TO_4_MAX = 4;

export function resolveSectionRatingInput(elements: unknown): RatingInputMode {
   return resolveRatingInput(elements);
}

export function isValidRank(value: number, max = RANK_1_TO_4_MAX): boolean {
   return Number.isFinite(value) && value >= RANK_1_TO_4_MIN && value <= max;
}

/** Single-digit ranks 1..max only (no 0→10 behavior). */
export function applyRankDigit(digit: string, max = RANK_1_TO_4_MAX): number {
   if (!/^[0-9]$/.test(digit)) {
      return 0;
   }
   const parsed = parseInt(digit, 10);
   return isValidRank(parsed, max) ? parsed : 0;
}

export function sanitizeRank(raw: unknown, max = RANK_1_TO_4_MAX): number {
   if (raw === null || raw === undefined || raw === "") {
      return 0;
   }
   const parsed = parseInt(String(raw).trim(), 10);
   if (!Number.isFinite(parsed) || !isValidRank(parsed, max)) {
      return 0;
   }
   return parsed;
}

export function formatRankDisplay(rating: number, max = RANK_1_TO_4_MAX): string {
   return isValidRank(rating, max) ? String(rating) : "";
}

export { isOverlayRatingInput, resolveRatingInput };
export type { RatingInputMode };
